var $ = require('jquery');
var ko = require('knockout');
var ContentLibraryViewModel = require('./content-library.vm.js');

$(function () {
    function bindContentLibraryViewModel(el) {
        var $el = $(el);
        var dataContentLibrary = $el.data('ws-content-library');
        ko.applyBindings(new ContentLibraryViewModel(dataContentLibrary, orderPageUrl), el);
    }

    $('.ws-content-library:not(.lazyload)').each(function (index, item) {
        bindContentLibraryViewModel(item);
    });

    $(document).on('lazyloaded', '.ws-content-library', function (e) {
        if (e.currentTarget === e.target) {
            bindContentLibraryViewModel(e.target);
        }
    });
});